module.exports = __webpack_public_path__ + "img/avatar.f7318321.png";